import React from "react";
import PropTypes from "prop-types";
import { Polygon } from "react-leaflet";

const DistrictPolygon = props => {
  const { shape } = props;
  return (
    <Polygon
      positions={shape || []}
      stroke={true}
      fillOpacity={0.2}
      weight={2}
      color={"#F00"}
      fillColor={"#0F0"}
    />
  );
};

DistrictPolygon.propTypes = {
  shape: PropTypes.array
};

export default DistrictPolygon;



/** WEBPACK FOOTER **
 ** ./src/components/DistrictPolygon.jsx
 **/